module.exports = __webpack_public_path__ + "static/img/bg@2x.7d3e6cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/JuneRecharge/bg@2x.png
// module id = 7N6P
// module chunks = 69